import { clearTabFilters, getUserPreferences, saveTabFilters, setTabFilters } from './userPreferences.action';

export { userPreferencesReducer } from './userPreferences.reducer';
export { watchUserPreferences } from './userPreferences.saga';
export { userPreferencesService } from './userPreferences.service';

export const userPreferencesActions = {
    getUserPreferences,
    setTabFilters,
    saveTabFilters,
    clearTabFilters,
};
